import * as XLSX from "xlsx";
import moment from "moment";
import { extractExamFromMetadata } from "../../utils/metadata";
import { PhoneNumber } from "../../utils/phoneNumber";

const findConclusion = (exam: Exam): string => {
  const conclusion =
    exam?.form.find((field) => field.type === "conclusiones")?.response
      ?.input_value || "otro";

  return conclusion.replaceAll("_", " ").toUpperCase();
};

const findExam = (appointment: any) => {
  return extractExamFromMetadata(appointment.metadata);
};

const findConclusionComents = (exam: Exam): string => {
  const conclusionComments = exam?.form.find((field) => field.type === "textarea")?.response
    ?.input_value || null;
  return conclusionComments
}


const returnDateTime = (rowData: any) => {
  if (rowData?.type === 'Visita a Domicilio' || rowData?.type === 'Videollamada') return "---";
  if (rowData?.startTime) return `${rowData.date} - ${rowData?.startTime}`;
  return "---";
}

const observations = (item: any) => {
  const conclusionComments = findConclusionComents(findExam(item) as Exam) || ''
  return conclusionComments.length > 0 ? conclusionComments.trim() : '---'
}

const exam_aptitud = (item: any) => {
  const aptitud = findConclusion(findExam(item) as Exam)
    .split("_")
    .join(" ")
    .toLocaleLowerCase();
  return aptitud;
}



const employeeResult = (item: any) => {
  const simplified = item?.metadata?.simplified;
  const form = simplified
    ?.map((s: any) => s.form)
    ?.filter((f: any) => f !== undefined);
  //console.log('FORM', form)
  const diagnostico = form?.map((a: any) => {
    const isICTraumatologica = a?.find((element: any) => element?.label === 'Interconsulta Traumatológica');
    if (isICTraumatologica) {
      const result = a?.find((element: any) => element?.label === 'Informe');
      return result?.response?.input_value;
    }

    const isICNeurologica = a?.find((element: any) => element?.label === "Interconsulta Neurologica");
    if (isICNeurologica) {
      const result = a?.find((element: any) => element?.label === 'Informe');
      return result?.response?.input_value;
    }

    return undefined;
  });

  if (!diagnostico || diagnostico.every((d: any) => d === undefined)) {
    return "---";
  }

  return diagnostico;
};




const returnDiagnostics = (rowData: any) => {
  if (rowData?.patient && rowData?.patient?.candidate) {
    return exam_aptitud(rowData)
  };
  if (rowData?.patient && rowData?.patient?.employee) {
    return employeeResult(rowData)
  };

  return "---"
}



const returnPracticeName = (rowData: any) => {
  const molde = rowData?.metadata?.molde || [];
  const exam = rowData?.metadata?.exam || [];
  const practices = rowData?.metadata?.practices || [];
  const practiceInMolde = rowData?.metadata?.molde?.practices || [];
  const allPractices = [];
  if (exam.practices) {
    allPractices.push(...exam.practices);
  }
  if (molde.exams && molde.exams[0] && molde.exams[0].practices) {
    allPractices.push(...molde.exams[0].practices);
  }
  if (practices) {
    allPractices.push(...practices);
  }
  if (practiceInMolde) {
    allPractices.push(...practiceInMolde);
  }
  const practiceNames =
    allPractices.length > 0
      ? allPractices.map((practice: any) => practice.name).join(", ")
      : molde.practices && molde.practices.length > 0
        ? molde.practices.map((practice: any) => practice.name).join(", ")
        : practices && practices.length > 0
          ? practices.map((practice: any) => practice.name).join(", ")
          : practiceInMolde && practiceInMolde.length > 0
            ? practiceInMolde.map((practice: any) => practice.name).join(", ")
            : "---";

  if (rowData?.metadata) return practiceNames
  if (rowData?.type === 'Visita a Domicilio' || rowData?.type === 'Videollamada') return rowData?.practiceName
  return '---'

}

const horaAdmision = (rowData: any) => {
  //console.log('rowData', rowData)
  if (!rowData?.actions || rowData?.actions?.length === 0) {
    const admissionTime = rowData?.admissionTime;
    const [date, time] = admissionTime.split(" ");
    return { fecha: date, hora: time };
  }

  const admitido = rowData.actions.find(
    (action: any) => action.action === 'ADMITIDO' || action.action === 'ADMITIDO/TOTEM'
  );

  if (!admitido) {
    return { fecha: '---', hora: '---' };
  }

  return {
    fecha: moment(admitido.date).format('DD/MM/YYYY'),
    hora: moment(admitido.date).format('HH:mm')
  };
};


const personalInformation = (item: any) => {
  let name: string = '---';
  let dni: string = '---';
  let phone: string = '---';
  let puesto: string = '---';
  let tipo: string = '---';
  let email: string = '---';
  let company_name: string = '---';
  let company_cuit: string = '---';
  let patient: any = item?.patient;
  let metadata_patient: any = item?.metadata?.patient;

  name = patient?.candidate?.user?.name?.toUpperCase() || patient?.employee?.user?.name?.toUpperCase() || metadata_patient?.name?.toUpperCase() || '---';
  dni = patient?.candidate?.user?.DNI || patient?.employee?.user?.DNI || metadata_patient?.dni || '---';
  phone = PhoneNumber(patient?.employee?.phoneNumber) || PhoneNumber(patient?.candidate?.phoneNumber) || PhoneNumber(metadata_patient?.phone) || '---';
  puesto = patient?.employee?.positionName || patient?.candidate?.positionName || '---';
  tipo = patient?.candidate ? 'Candidato' : 'Empleado';
  email = patient?.candidate?.email || patient?.employee?.user?.email || '---';
  company_name = metadata_patient?.companySocialReason || patient?.employee?.company?.socialReason || patient?.candidate?.company?.socialReason;
  company_cuit = metadata_patient?.companyCuit || patient?.employee?.company?.cuit || patient?.candidate?.company?.cuit;
  return { name, dni, phone, puesto, tipo, email, company_name, company_cuit }
}

const professional = (item: any) => {
  const metadata = item?.metadata
  const molde = metadata?.molde || [];
  const exam = metadata?.exam || [];
  const simplified = metadata?.simplified || [];

  let professional = null;
  let allowExam: string[] = [];


  if ((molde || exam) && (item.status !== 'Eliminado' || item.status !== 'Ausente')) {
    allowExam = ['EXAM', 'EXAM_IN_MOLDE']
    professional = simplified?.filter((p: any) => allowExam.includes(p.type))[0]?.professional
    if (professional) {
      return `${professional?.title} ${professional?.name}`
    }
  }

  return '---'
}




const turnExcelReport = async (rowData: any) => {
  if (rowData.length === 0 || !rowData) return

  const headers = [
    "Fecha del turno",
    "Fecha de admisión",
    "Hora de admisión",

    "DNI",
    "Nombre",
    "Teléfono",
    "Email",
    "Puesto",
    "Tipo",
    "Empresa",
    "CUIL",


    "Examen",
    "Prácticas",
    "Aptitud",
    "Observaciones",
    "Profesional de la Aptitud",
  ];

  const excelDataPromises = rowData?.map(async (item: any) => {
    const appDateTime = returnDateTime(item);
    const molde = item?.metadata?.molde || [];
    const exam = item?.metadata?.exam || [];
    const examName = exam.name || (molde.exams && molde.exams[0] && molde.exams[0].name) || "---";
    const diagnostics = returnDiagnostics(item) || "---";


    return [
      appDateTime,
      horaAdmision(item)?.fecha,
      horaAdmision(item)?.hora,

      personalInformation(item)?.dni,
      personalInformation(item)?.name,
      personalInformation(item)?.phone,
      personalInformation(item)?.email,
      personalInformation(item)?.puesto,
      personalInformation(item)?.tipo,
      personalInformation(item)?.company_name,
      personalInformation(item)?.company_cuit,

      examName,
      returnPracticeName(item),
      diagnostics,
      observations(item),
      professional(item),
    ]
  })
  const excelData = await Promise.all(excelDataPromises);

  // Asegurarse de que todo sea texto
  const formattedExcelData = excelData.map(row => row.map((cell: any) => ({ v: cell, z: '@' })));

  const ws = XLSX.utils.aoa_to_sheet([headers.map(header => ({ v: header, z: '@' })), ...formattedExcelData]);

  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, "Sheet1");

  const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
  const blob = new Blob([excelBuffer], {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  });
  const url = URL.createObjectURL(blob);
  const date = moment().format('DD/MM/YYYY');
  let filename = `Reportes-Servicios-Prestaciones-Turnos-${date}.xlsx`;



  const link = document.createElement("a");
  link.href = url;
  link.download = filename;
  link.click();

  return excelDataPromises;

}

export default turnExcelReport